import graphic from "../images/graphic design.png";
import webdev from "../images/website developer.png";
import js from "../images/js dev.png"
import full from "../images/fullstack.png";
import backend from "../images/backend.png";
import ui from "../images/ui dev.png";
import app from "../images/appdev.png";
import db from "../images/db dev.png";

export const courses = [
  {
    id: 0,
    cover: webdev, // Example for another item using the same image
    title: "Website Development",
    category: "Development",
    author: "Alex",
    date: "Jan 1, 2025",
  },
  {
    id: 1,
    cover: graphic, // Example for another item using the same image
    title: "Graphic Designing",
    category: "Design",
    author: "Alex",
    date: "Jan 1, 2025",
  },
  {
    id: 2,
    cover: js, // Example for another item using the same image
    title: "JavaScript Developer",
    category: "Development",
    author: "Alex",
    date: "Jan 1, 2025",
  },
  {
    id: 3,
    cover: full, // Example for another item using the same image
    title: "FullStack Development",
    category: "Development",
    author: "Alex",
    date: "Jan 1, 2025",
  },
  {
    id: 4,
    cover: backend, // Example for another item using the same image
    title: "Backend Developer",
    category: "Development",
    author: "Alex",
    date: "Jan 1, 2025",
  },
  {
    id: 5,
    cover: ui, // Example for another item using the same image
    title: "Ui Designing",
    category: "Design",
    author: "Alex",
    date: "Jan 1, 2025",
  },
  {
    id: 6,
    cover: app, // Example for another item using the same image
    title: "App Development",
    category: "Development",
    author: "Alex",
    date: "Jan 1, 2025",
  },
  {
    id: 7,
    cover: db, // Example for another item using the same image
    title: "Database Designing",
    category: "Design",
    author: "Alex",
    date: "Jan 1, 2025",
  },
];
